package com.havn.app.core.platform

actual object HavnClipboard {
    actual fun copyText(text: String): Boolean = copyBrowserText(text)
}

@Suppress("UnsafeCastFromDynamic")
private fun copyBrowserText(text: String): Boolean = js(
    """
    (() => {
        const value = String(text || "");
        if (window.navigator && window.navigator.clipboard && typeof window.navigator.clipboard.writeText === "function") {
            window.navigator.clipboard.writeText(value).catch(() => {});
            return true;
        }
        const element = document.createElement("textarea");
        element.value = value;
        element.setAttribute("readonly", "readonly");
        element.style.position = "fixed";
        element.style.opacity = "0";
        document.body.appendChild(element);
        element.select();
        let ok = false;
        try { ok = document.execCommand("copy"); } catch (_) { ok = false; }
        document.body.removeChild(element);
        return ok;
    })()
    """
) as Boolean
